import { useState, useCallback, useEffect, useMemo } from 'react';
import { defaultFunction } from '../../utils/bundle.esm2.js';

const useCounter = (config) => {
  const { onChange = defaultFunction, initialValue = 0, min = 0 } = config;
  const { onAdd = defaultFunction, onSubtract = defaultFunction } = config;
  const { max = 100, steps = 1 } = config;
  const [quantity, setQuantity] = useState(initialValue);
  const add = useCallback(() => {
    if (quantity >= max)
      return;
    setQuantity((prev) => {
      const newQuantity = prev + steps;
      onChange(newQuantity);
      onAdd(newQuantity);
      return newQuantity;
    });
  }, [quantity, max, steps, onChange, onAdd]);
  const subtract = useCallback(() => {
    if (quantity <= min)
      return;
    setQuantity((prev) => {
      const newQuantity = prev - steps;
      onChange(newQuantity);
      onSubtract(newQuantity);
      return newQuantity;
    });
  }, [quantity, min, steps, onChange, onSubtract]);
  useEffect(() => {
    setQuantity(initialValue);
  }, [initialValue]);
  return useMemo(
    () => ({
      add,
      subtract,
      quantity
    }),
    [add, subtract, quantity]
  );
};

export { useCounter as default };
//# sourceMappingURL=bundle.esm2.js.map
